import React, { useCallback } from "react";
import styles from "./styles.module.scss";
import useDatafileIcons from "app/components/inputs/SelectBox/helpers/DatafileIcons";
import playIcon from "app/images/play_btn.svg";
import duration from "app/components/inputs/SelectBox/helpers/DurationConverter";
import { cls } from "app/utils";
import checkmark from "../../../../public/images/checkmark.svg";
import { Spinner } from "app/components/Loading";
import { useTranslation } from "react-i18next";
import i18n from "app/i18n";
import MulticamVideoBadge from "app/components/MulticamVideoBadge";
import { Media } from "app/models/MediaModel";
import { MediaModel } from "app/models";

interface Props {
  showTags?: boolean;
  showPlayIcon?: boolean;
  thumbnailClassname?: string;
  hasGradientOverlay?: boolean;
  data: MediaModel;
  onSelectMedia?: (data: MediaModel) => void;
  isSelected?: boolean;
}

const ResourceCard = ({
  data,
  showTags = true,
  showPlayIcon = true,
  thumbnailClassname,
  hasGradientOverlay = true,
  isSelected,
}: Props) => {
  const { t } = useTranslation();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };

    const formattedDate = date.toLocaleDateString(i18n.language, options);

    return formattedDate;
  };
  const { dataFileIconHandler } = useDatafileIcons();

  const displayThumbnail = useCallback((data: Media) => {
    if (!data || !data.object) {
      return null;
    }

    if (data.object === "video") {
      return data.processed ? (
        data.thumbnails && data.thumbnails.default && (
          <>
            <MulticamVideoBadge
              data={data}
              classNames={styles.mutlicam_badge}
            />
            {data?.duration > 0 && showPlayIcon && (
              <div className={styles.play_wrapper}>
                <img src={playIcon} alt="play" />
                <span>{duration(data?.duration)}</span>
              </div>
            )}
            <img src={data?.thumbnails?.default} alt="media thumbnail" />
          </>
        )
      ) : (
        <span className={styles.loading_container}>
          <Spinner />
        </span>
      );
    }

    if (data.object === "image") {
      if (data.mediumUrl) {
        return <img src={data.mediumUrl} alt="media thumbnail" />;
      }
      return (
        data.originalUrl && <img src={data.originalUrl} alt="media thumbnail" />
      );
    }

    if (data.object === "datafile") {
      return <img src={dataFileIconHandler(data.extension)} alt="datafile" />;
    }

    if (data.object === "audio") {
      return <img src={dataFileIconHandler(data.object)} alt="datafile" />;
    }

    return null;
  }, []);

  return (
    <>
      <div>
        <div
          className={cls(styles.thumbnail_wrapper, thumbnailClassname, {
            [styles.selectedMediaData]: isSelected,
          })}
        >
          {isSelected && (
            <span className={styles.checkmark_container}>
              <img
                src={checkmark}
                alt="checkmark"
                className={styles.checkmark}
              />
            </span>
          )}
          {displayThumbnail(data)}
          <div
            className={cls({ [styles.thumbnail_overlay]: hasGradientOverlay })}
          />
          {showTags && (
            <div className={styles.tags_overlay}>
              {data.tags && data.tags.length ? (
                <>
                  #
                  {data.tags.map((tag) => {
                    return (
                      <span key={tag} className={styles.tag}>
                        {tag}
                        {data.tags.length > 1 ? "," : ""}
                      </span>
                    );
                  })}
                </>
              ) : (
                t("No Tags")
              )}
            </div>
          )}
        </div>
      </div>
      <div className={styles.media_info}>
        <p className={styles.post_count}>
          {t("count_post", {
            count: data.postsCount,
          })}
        </p>
        <p className={styles.posted_at}>{formatDate(data.createdAt)}</p>
      </div>
    </>
  );
};

export default ResourceCard;
